<template>
  <b-modal
    ref="changeTariffModal"
    centered
    size="md"
    title="Change tariff for reseller"
    hide-header-close
    scrollable
    footer-bg-variant=""
    @hidden="unselectReseller(), clearNewTariff()">

    <b-form @submit.stop.prevent>
      <b-form-group
        id="tariffsDropdown"
        label="New Tariff"
        label-for="">
        <b-form-select
          :disabled="activeTariffsEmpty"
          v-model="newTariff">
          <b-form-select-option
            v-for="tariff in enabledTarrifs(selectedReseller.tariff._id)"
            :key="`tariff-${tariff._id}`"
            :value="tariff._id">
            {{ tariff.name }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>
    </b-form>

    <reseller-details-plate />

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          id="cancelModal"
          variant="outline-secondary"
          size="md"
          @click="hideModal('changeTariffModal')">
          Cancel
        </b-button>
        <b-button
          variant="primary"
          v-wave
          size="md"
          class="ml-auto"
          :disabled="resellersResponses('changeResellerTariff') || activeTariffsEmpty || tariffNotChanged"
          @click="submitReseller()">
          Submit
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { CHANGE_RESELLER_TARIFF, UNSELECT_RESELLER } from '@/core/services/store/resellers.module'
import { showModal, hideModal } from '@/core/utils'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import ResellerDetailsPlate from './ResellerDetailsPlate.vue'

export default {
  name: 'ModalChangeTariff',
  components: {
    ResellerDetailsPlate,
  },
  data() {
    return {
      newTariff: null,

      showModal,
      hideModal,
    }
  },
  computed: {
    ...mapGetters([
      'selectedReseller',
      'selectedResellerId',
      'resellerStatusBadge',
      'resellersResponses',

      'enabledTarrifs',
      'enabledTarrifs',
      'activeTariffsEmpty',
      'excludedActiveTariffs',
    ]),

    tariffNotChanged() {
      return this.newTariff === this.selectedReseller.tariff._id
    }
  },
  mounted() {
    eventBus.$on('openModal', type => {
      this.newTariff = this.selectedReseller.tariff._id
      this.showModal(type)
    })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    submitReseller() {
      this.$store
        .dispatch(CHANGE_RESELLER_TARIFF, {
          reseller_id: this.selectedReseller.id,
          tariff_id: this.newTariff
        })
        .then(() => {
          this.hideModal('changeTariffModal')
        })
    },

    unselectReseller() {
      this.$store.commit(UNSELECT_RESELLER)
    },

    clearNewTariff() {
      this.newTariff = null
    }
  }
}
</script>
